import * as React from 'react';
import Row from 'components/Row';
import Text from 'components/Text';
import Link from 'components/Link';
import Field from 'components/Field';
import Radio from 'components/Radio';
import Image from 'components/Image';
import Button from 'components/Button';
import BoxBody from 'components/BoxBody';
import BoxHeader from 'components/BoxHeader';
import LinkConstants from 'constants/LinkConstants';
import ClaimDeviceClasses from 'user/components/ClaimDeviceClasses';
// @ts-ignore
import { ConfirmableDeviceType, deviceString } from 'entities/Device';

import './styles/ClaimDevice.scss';

export type Props = {
  deviceClasses: string[];
  claimToken: string;
  deviceAddress: string;
  deviceType: ConfirmableDeviceType;
  mergeAccounts: boolean;
  submitDisabled?: boolean;
  displayMergeAccountsConfirmation: boolean;
  onMergeAccountsChange: (mergeAccounts: boolean) => void;
  onClaim: () => void;
  onConfirmMerge: () => void;
  onCancelMerge: () => void;
};

export default function ClaimDevice(props: Props) {
  const deviceName = deviceString(props.deviceAddress, props.deviceType);

  const renderMergeAccountsConfirmation = () => {
    return (
      <>
        <BoxHeader title="Merge accounts?" size="small" />
        <BoxBody>
          <Row>
            <Text color="thunder">
              Your account will show classes from both accounts. This action cannot be undone.
            </Text>
          </Row>
          <Row size="small">
            <Button
              color="lava"
              onClick={props.onConfirmMerge}
              disabled={props.submitDisabled}
              loading={props.submitDisabled}>
              Merge accounts
            </Button>
          </Row>
          <Link color="lava" onClick={props.onCancelMerge}>
            Cancel
          </Link>
        </BoxBody>
      </>
    );
  };

  const renderClaimDevice = () => {
    return (
      <div className="ClaimDevice">
        <Image src={require('assets/images/claim-device.svg')} />
        <BoxHeader title="Existing account found" size="xsmall" />
        <BoxBody>
          <ClaimDeviceClasses deviceName={deviceName} deviceClasses={props.deviceClasses} />
          <Link href={LinkConstants.CLAIM_DEVICE_HELP} target="_blank">
            Learn More
          </Link>
        </BoxBody>
        <BoxBody divided>
          <Field>
            <Row size="small">
              <Radio
                data-test="steal-radio"
                size="small"
                label="I don't recognize that account"
                labelNote={`Just ${deviceName} will be added`}
                checked={!props.mergeAccounts}
                onChange={() => props.onMergeAccountsChange(false)}
              />
            </Row>
            <Row flush>
              <Radio
                data-test="merge-radio"
                size="small"
                label="That's also my account"
                labelNote="Your accounts will be merged"
                checked={props.mergeAccounts}
                onChange={() => props.onMergeAccountsChange(true)}
              />
            </Row>
          </Field>
          <Button
            onClick={props.onClaim}
            disabled={props.submitDisabled}
            loading={props.submitDisabled}>
            Submit
          </Button>
        </BoxBody>
      </div>
    );
  };

  return props.displayMergeAccountsConfirmation
    ? renderMergeAccountsConfirmation()
    : renderClaimDevice();
}
